import { render, staticRenderFns } from "./profile-addresses.vue?vue&type=template&id=1b0be10d&scoped=true&"
import script from "./profile-addresses.vue?vue&type=script&lang=js&"
export * from "./profile-addresses.vue?vue&type=script&lang=js&"
import style0 from "./profile-addresses.vue?vue&type=style&index=0&id=1b0be10d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0be10d",
  null
  
)

export default component.exports